// extracted by mini-css-extract-plugin
module.exports = {"galleryImage":"GalleryImageElement_galleryImage__j8C7J","galleryImage--fullscreen":"GalleryImageElement_galleryImage--fullscreen__pGZMS"};